// extracted by mini-css-extract-plugin
export default {"mainButton":"styles_mainButton__nvc7A","innerButton":"styles_innerButton__XmvCL","btnGroup":"styles_btnGroup__C4rWX"};